/**
 * El copy de configuración (GKTIBO-125).
 *
 * Vive en el panel y no en el servidor, como todo lo que lee el dueño: el
 * mismo criterio por el que `aperturaDeConversacion` devuelve el id del tema y
 * no la pregunta (D6). Tenerlo en dos lugares es tenerlo mal en uno.
 */
export const configuracion = {
  titulo: 'Configuración',
  canales: 'Canales',
  bajadaDeCanales:
    'Por dónde te escriben tus clientes. Tu bot ya sabe atender — esto es lo que falta para que alguien pueda hablarle.',
  /**
   * Que el dueño no sienta que sin canal no puede hacer nada.
   *
   * Es la contracara del aviso: se le dijo una vez que falta, y acá se le dice
   * qué SÍ puede hacer mientras tanto.
   */
  mientrasTanto:
    'Mientras tanto tu bot no queda parado: seguí probándolo y enseñándole todo lo que corrijas.',
  sinNegocio: 'Tu cuenta todavía no tiene un negocio asociado.',
  /** El indicador discreto del armazón. No insiste: dice y se queda quieto. */
  sinCanalConectado: 'Sin canal conectado',
} as const;
